export const DENY_PERMISSION = (auth) => false;
export const getUsername = (auth) => {
    var _a, _b, _c, _d;
    const firstName = (_b = (_a = auth.user) === null || _a === void 0 ? void 0 : _a.firstName) !== null && _b !== void 0 ? _b : "";
    const lastName = (_d = (_c = auth.user) === null || _c === void 0 ? void 0 : _c.lastName) !== null && _d !== void 0 ? _d : "";
    return `${firstName} ${lastName}`;
};
